import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import TabMaterial from "@material-ui/core/Tab";
import styled from "styled-components";

const StyledAppBar = styled(AppBar)`
  background-color: #000 !important;
`;

export const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      aria-labelledby={`simple-tab-${index}`}
      className="w-100"
      {...other}
    >
      {value === index && children}
    </div>
  );
};

export const Tab = ({ tabs = [], value, onChange }) => {
  return (
    <>
      <StyledAppBar position="static">
        <Tabs value={value} onChange={onChange} aria-label="header" centered>
          {tabs.map((label) => (
            <TabMaterial key={label} label={label} />
          ))}
        </Tabs>
      </StyledAppBar>
    </>
  );
};

// <TabPanel value={value} index={0}>
//         Item One
// </TabPanel>
